import { Component, Vue } from "vue-property-decorator";

import { SideNav } from "@/layout";
import { ConfirmDelete, Lightbox } from "@/components";
import { ErrorCode, ErrorMessage } from "@/constant";
import { QuizModel } from "@/models";
import { Common } from "../Common";

export class SearchForm {
    date = '';
    tid = '';
    clid = '';
    sid = '';
    cid = '';
    active = '';
}

type response = { [key: string]: unknown };

@Component<AdminQuizPaperController>({
    components: {
        SideNav, ConfirmDelete, Lightbox
    }
})
export default class AdminQuizPaperController extends Vue {
    private doubleClick = false;
    private searchForm = new SearchForm();
    private cityList: { [key: string]: any } = {};
    private schoolList: { [key: string]: any } = {};
    private classList: object = {};
    private teacherList: object = {};
    private paperList: object = {};
    private num = 0;
    private pageHtml = "";
    private qid = '';

    private identity = window.localStorage.getItem('admin_identity') as string;
    private sid = window.localStorage.getItem('admin_sid') as string;
    private cid = '';
    private token = window.localStorage.getItem('adminToken') as string;

    private errorMsg = "";
    private openLB = false;
    private errNo!: number;

    public async created() {
        if (this.identity == "1") {
            this.cityList = await Common.getSchoolCity(); //取得有分校之縣市
        } else {
            this.cityList = await Common.getCity(this.sid); //取得該分校之縣市
            this.cid = this.cityList[0].cid;
            this.searchForm.cid = this.cid;

            const school = window.localStorage.getItem('admin_school') as string;
            this.schoolList[0] = {
                sid: this.sid,
                name: school,
            };
            this.searchForm.sid = this.sid;
            this.getClass(this.sid);
        }
        this.getPaperList();
    }

    // 取得 該縣市的分校列表 
    private async getSchool(cid: string) {
        if (this.identity == "1") {
            this.searchForm.sid = '';
            this.searchForm.clid = '';
            this.searchForm.tid = '';

            this.schoolList = await Common.getSchool(cid);
            this.classList = [];
            this.teacherList = [];
        }
    }

    // 取得 該分校的班級列表
    private async getClass(sid: string) {
        this.searchForm.clid = '';
        this.searchForm.tid = '';

        this.classList = await Common.getClass(2, sid, 0);
        this.teacherList = [];
    }

    // 取得 該班級的老師列表
    private async getTeacher(clid: string) {
        this.searchForm.tid = '';
        this.teacherList = await Common.getTeacher(2, clid, 0);
    }

    private async getPaperList() {
        if (this.identity == '2' && (this.searchForm.cid == '' || this.searchForm.sid == '')) {
            this.searchForm.cid = this.cid;
            this.searchForm.sid = this.sid;
            this.getClass(this.sid);
        }
        const item: { [key: string]: string } = {
            page: this.$route.query.page as string,
            date: this.searchForm.date,
            tid: this.searchForm.tid,
            clid: this.searchForm.clid,
            sid: this.searchForm.sid,
            cid: this.searchForm.cid,
            active: this.searchForm.active,
            token: this.token,
        }
        const data = await QuizModel.getPaperList(item) as response;
        Common.checkToken(data.ERR_CODE as number);
        this.num = data.num as number;
        this.paperList = data.list as object;
        this.pageHtml = data.pageHtml as string;
    }

    private async delPaper(id: string) {
        const item: { [key: string]: string } = {
            qid: id,
            token: this.token,
        };
        const errNo = await QuizModel.checkPaper(item);
        if (errNo === 3) {
            this.$emit("openConfirmDelete", true, '此組卷已有學生測驗，確認刪除?');
        } else {
            this.$emit("openConfirmDelete", true);
        }
        this.qid = id;
    }

    private async deletePaper() {
        if (!this.doubleClick) {
            this.doubleClick = true;

            const item: { [key: string]: string } = {
                qid: this.qid,
                token: this.token,
            }
            this.errNo = await QuizModel.delPaper(item);
            this.$emit("closeConfirmDelete", false);
            Common.checkToken(this.errNo);
            this.errorMsg = ErrorMessage[this.errNo];
            this.openLB = true;
            this.doubleClick = false;
        }
    }

    private closeLB() {
        this.openLB = false;
        if (this.errNo === ErrorCode.Success) {
            this.$router.go(0); //reload page
        }
    }
}
